<template>
  <div class="window-body">
    <ul class="tree-view">
      <li>
        <details>
          <summary>1997</summary>
          <ul>
            <li>
              <details>
                <summary>Born</summary>
                <ul>
                  <li>Not much to say here</li>
                </ul>
              </details>
            </li>
          </ul>
        </details>
      </li>
      <li><nav></nav>
        <details>
          <summary>June 2015</summary>
          <ul>
            <li>
              <details>
                <summary>Graduated High School</summary>
                <ul>
                  <li>wow. what a roller coaster :-)</li>
                </ul>
              </details>
            </li>
          </ul>
        </details>
      </li>
      <li>
        <details>
          <summary>Summer 2018</summary>
          <ul>
            <li>
              <details>
                <summary>Cyber Security Intern</summary>
                <ul>
                  <li>
                    Working for the summer in the Cyber Resiliency department at
                    the MITRE Corporation in Bedford, MA
                  </li>
                </ul>
              </details>
            </li>
          </ul>
        </details>
      </li>
      <li>
        <details>
          <summary>Summer 2019</summary>
          <ul>
            <li>
              <details>
                <summary>Cyber Security Intern</summary>
                <ul>
                  <li>
                    Working for the summer in the Cyber Resiliency department at
                    the MITRE Corporation in Bedford, MA
                  </li>
                </ul>
              </details>
            </li>
          </ul>
        </details>
      </li>
      <li>
        <details>
          <summary>December 2019</summary>
          <ul>
            <li>
              <details>
                <summary>Graduated McGill University</summary>
                <ul>
                  <li>
                    Bachelors of Software Engineering in Software Engineering
                    from McGill University, Montreal, QC, Canada
                  </li>
                </ul>
              </details>
            </li>
          </ul>
        </details>
      </li>
      <li>
        <details>
          <summary>July 2020</summary>
          <ul>
            <li>
              <details>
                <summary>Gorilla Group</summary>
                <ul>
                  <li>Software Engineer at Gorilla Group</li>
                </ul>
              </details>
            </li>
          </ul>
        </details>
      </li>
      <li>
        <details>
          <summary>April 2021</summary>
          <ul>
            <li>
              <details>
                <summary>Software Engineer I</summary>
                <ul>
                  <li>Software Engineer I at Cox Automotive</li>
                </ul>
              </details>
            </li>
          </ul>
        </details>
      </li>
      <li>
        <details>
          <summary>December 2021</summary>
          <ul>
            <li>
              <details>
                <summary>Software Development Engineer</summary>
                <ul>
                  <li>SDE at Amazon Web Services (AWS)</li>
                </ul>
              </details>
            </li>
          </ul>
        </details>
      </li>
      <li>
        <details>
          <summary>Present Day (2026)</summary>
          <ul>
            <li>
              <details>
                <summary>Platform Software Engineer</summary>
                <ul>
                  <li>
                    Platform Software Engineer at Imply
                  </li>
                </ul>
              </details>
            </li>
          </ul>
        </details>
      </li>
    </ul>
  </div>
</template>

<style scoped src="98.css">
</style>
